<abp-modal [(visible)]="openModal" (disappear)="modalClose.emit(false)" [options]="{ size: 'xl' }">
  <ng-template #abpHeader> </ng-template>

  <ng-template #abpBody>
    <div class="gap-3">
      <div class="card">
        <app-current-events [asset]="asset"/>
      </div>
    </div>
  </ng-template>
  <ng-template #abpFooter>
    <button type="button" class="btn btn-secondary" abpClose>
      {{ 'AbpUi::Close' | abpLocalization }}
    </button>
  </ng-template>
</abp-modal>
